import React from 'react';
import { cn } from '../../../utils/cn';

const FormGroup = ({ 
  label,
  children,
  required = false,
  error,
  help,
  className,
  ...props 
}) => {
  return (
    <div
      className={cn(
        'space-y-2',
        className
      )}
      {...props}
    >
      {label && (
        <label className={cn(
          'block text-sm font-medium text-gray-700',
          required && 'after:content-["*"] after:text-red-500 after:ml-1'
        )}>
          {label}
        </label>
      )}
      
      {children}
      
      {help && !error && (
        <p className="text-sm text-gray-500">{help}</p>
      )}
      
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormGroup;